module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-camisa-uniforme-personalizado-staff-768x591.8087ce10.jpg";